import { render, staticRenderFns } from "./PopupPage.vue?vue&type=template&id=fa19949e&"
import script from "./PopupPage.vue?vue&type=script&lang=js&"
export * from "./PopupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports